import { BORDERS } from "../constants";
export const border = (style = "default") => (BORDERS[style] ? BORDERS[style] : BORDERS.default);
